<template>
  <v-breadcrumbs class="breadcrumbs" :items="items"></v-breadcrumbs>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    items: Array
  }
}
</script>

<style lang="scss" scoped>
.v-breadcrumbs {
  padding-left: 0px;
  padding-top: 0px;
}

</style>
